<script lang="js" setup>
import { computed, onMounted } from 'vue'
import { useAppVersionCheck } from '@/composables/useAppVersionCheck'

/**
 * "New version available" toast (mounted once in app.vue).
 *
 * Shows when `useAppVersionCheck` detects that a newer build was deployed than
 * the one this window is running. Persistent (no timeout) — the user either
 * refreshes right away or postpones with "Later", which hides it until the
 * window is next re-focused (see the composable). Refresh is a plain full
 * reload: the entry HTML is no-cache, so it always boots the new build.
 */
const { updateAvailable, dismissed, start, dismiss, refreshNow } = useAppVersionCheck()

onMounted(start)

const visible = computed(() => updateAvailable.value && !dismissed.value)

// The version THIS window is running (nuxt.config → runtimeConfig). Shown so
// there's a concrete number to read; the incoming build's number isn't known
// to the running app (the check only sees a build-id mismatch).
const appVersion = useRuntimeConfig().public.appVersion
</script>

<template>
  <VSnackbar
    :model-value="visible"
    :timeout="-1"
    color="primary"
    location="bottom end"
    variant="elevated"
    class="app-update-toast"
  >
    <div class="d-flex align-center gap-2">
      <VIcon
        icon="tabler-refresh-alert"
        size="20"
      />
      <span>A new version of ABAIntake is available (you're on v{{ appVersion }}).</span>
    </div>

    <template #actions>
      <VBtn
        size="small"
        variant="text"
        @click="dismiss"
      >
        Later
      </VBtn>
      <VBtn
        size="small"
        variant="elevated"
        color="white"
        class="text-primary font-weight-bold"
        @click="refreshNow"
      >
        Refresh
      </VBtn>
    </template>
  </VSnackbar>
</template>
